<script lang="ts" setup>
interface Props {
  description: string;
}

const props = defineProps<Props>();
const { t } = useI18n();
</script>

<template>
  <div :class="$style.root">
    <nuxt-img
      :class="$style.img_1"
      aria-label="For any purchases"
      format="webp"
      height="166"
      src="/img/block-for-purchases-nike.png"
      width="280"
    />
    <nuxt-img
      :class="$style.img_2"
      aria-label="For any purchases"
      format="webp"
      height="215"
      src="/img/block-for-purchases-phone.png"
      width="147"
    />
    <nuxt-img
      :class="$style.img_3"
      aria-label="For any purchases"
      format="webp"
      height="252"
      src="/img/block-for-purchases-case.png"
      width="338"
    />
    <div :class="$style.wrapper">
      <div :class="[$style.title, $style[`title-${$i18n.locale}`]]">
        {{ t("block.forPurchases2.title") }}
      </div>
      <div :class="$style.desc">
        {{ props.description }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.root {
  @apply rounded-[40px] relative flex flex-col w-full overflow-hidden;
  @apply px-[30px] py-[80px] md:py-10 lg:px-[30px] lg:py-16;
  @apply min-h-[500px] xxs:min-h-[530px];
  @apply bg-neutral-100 text-neutral-900;
}

.wrapper {
  @apply w-full md:w-8/12 lg:w-full mb-auto lg:mb-0 rtl:md:w-full rtl:md:pr-[100px];
}

.title {
  @apply font-extrabold leading-none mb-5;
  @apply text-[32px] xxs:text-[36px];
  &-en,
  &-id,
  &-da,
  &-et,
  &-hu,
  &-lt,
  &-nb,
  &-ro,
  &-sl,
  &-cs,
  &-el,
  &-fi,
  &-lv,
  &-nl,
  &-sk,
  &-sv,
  &-he,
  &-be,
  &-bg,
  &-it,
  &-tr,
  &-ua,
  &-zh,
  &-de,
  &-bg,
  &-ru,
  &-ja,
  &-th,
  &-pl,
  &-hi,
  &-ar,
  &-bn,
  &-ko,
  &-vi,
  &-sw {
    @apply text-[32px] xxs:text-[36px];
  }

  &-ja {
    @apply leading-[1.2];
  }

  &-zh {
    @apply leading-[1.2];
  }

  &-pt,
  &-fr,
  &-es {
    @apply text-[24px] xxs:text-[30px] 414:text-[32px] lg:text-[28px] xl:text-[32px];
  }
}

.desc {
  @apply text-[15px] w-full md:w-11/12 lg:w-7/12 rtl:md:w-full;
}

.img_1 {
  @apply hidden;

  @screen md {
    @apply block absolute right-0 bottom-0 -translate-y-[124%] translate-x-[10%] w-[340px];
  }
  @screen lg {
    @apply w-[280px] -translate-y-[140%] translate-x-[34%];
  }
  @screen xl {
    @apply translate-x-[20%];
  }
}

.img_2 {
  @apply absolute bottom-0 right-0 rotate-[270deg] translate-y-[26%] translate-x-[34%] h-[300px] w-auto scale-[0.8];

  @screen md {
    @apply left-0 right-auto translate-x-[46%] h-[246px] scale-[1];
  }
  @screen lg {
    @apply translate-y-[20%] translate-x-[40%] h-[215px];
  }
}

.img_3 {
  @apply absolute;
  @apply bottom-0 left-0 h-[240px] w-auto translate-y-[10%] -translate-x-[60%];

  @screen xxs {
    @apply -translate-x-[50%] w-[320px] h-auto;
  }
  @screen xs {
    @apply -translate-x-[38%];
  }
  @screen md {
    @apply right-0 left-auto w-[358px] -translate-x-0 translate-y-[20%];
  }
  @screen lg {
    @apply translate-x-[40%] w-[338px];
  }
  @screen xl {
    @apply translate-x-[20%];
  }
}
</style>
